<template>
  <section class="fold overflow-hidden">
    <div class="rl z text-center">
      <div
        class="mb-3 d-flex align-items-center justify-content-center lh-1 lbld"
      >
        <span class="cricle-green me-2"></span> House For Sale
      </div>
      <div class="f-xxlg lh-sm px-3">2206 N CloverLeaf Way</div>
      <div class="f-xlg">Saratoga Springs UT 84045</div>
      <div class="mt-3 f-xmlg lbld">${{ price }}</div>
      <div class="row mt-5">
        <div class="col-12 col-sm-6 text-center text-sm-end">
          <button
            class="btn btn-outline-primary shadow-sm text-light px-4 py-2 f-lg lbld btn-fold-w justify-content-center"
            @click="$emit('showphotos', true)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="me-2"
              height="24px"
              viewBox="0 -960 960 960"
              width="20px"
              fill="#fff"
            >
              <path
                d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm40-80h480L570-480 450-320l-90-120-120 160Zm-40 80v-560 560Zm140-360q25 0 42.5-17.5T400-620q0-25-17.5-42.5T340-680q-25 0-42.5 17.5T280-620q0 25 17.5 42.5T340-560Z"
              />
            </svg>
            Show Photos
          </button>
        </div>
        <div class="col-12 col-sm-6 text-center text-sm-start mt-3 mt-sm-0">
          <a
            id="contact-btn"
            href="#contact"
            class="btn btn-outline-light btn-contact shadow-sm px-4 py-2 f-lg lbld btn-fold-w justify-content-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="20px"
              class="me-2"
              fill="#fff"
            >
              <path
                d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z"
              />
            </svg>
            Contact Us
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['price'],
}
</script>

<style>
.btn-contact:hover svg {
  fill: #000;
}
</style>
